export default __webpack_public_path__ + "f8959da5654071334c20e0464f5c7049.png";